import { useOnChainTransfer } from '@modals/blockchain'
import { FullScreen } from '@modals/layout'
import { Center } from '@shared/components/layout'
import { useConnectWallet } from '@shared/wallet/hooks/useConnectWallet'

import { ReceiveConnected } from './Receive.Connected/Receive.Connected'
import { ReceiveDisconnected } from './Receive.Disconnected/Receive.Disconnected'

import type {
  BlockchainAbbreviation,
  BlockchainLocationMetadata,
  Maybe,
} from '@shared/graphql'

export interface ReceiveProps {
  /**
   * Chained transfer metadata.
   */
  transferMetadata?: Maybe<BlockchainLocationMetadata>
  /**
   * Wallet address.
   */
  address?: string
  /**
   * Chain.
   */
  chain?: BlockchainAbbreviation
  /**
   * Wallet description.
   */
  description?: string
}

export const Receive: React.FC<ReceiveProps> = ({
  transferMetadata,
  address,
  chain,
  description,
}) => {
  const [{ destination }] = useOnChainTransfer()

  const { isConnected } = useConnectWallet()

  return (
    <FullScreen totalSteps={2}>
      <Center>
        {isConnected ? (
          <ReceiveConnected
            address={destination?.address ?? address}
            chain={destination?.chain ?? chain}
            transferMetadata={transferMetadata}
          />
        ) : (
          <ReceiveDisconnected
            address={destination?.address ?? address}
            chain={destination?.chain ?? chain}
            description={destination?.description ?? description}
          />
        )}
      </Center>
    </FullScreen>
  )
}
